"use client"

import { signIn } from 'next-auth/react'
import Container from '@components/container'
import { Button, TitleBackgroundBlock, Alert, Typography, Link } from '@shc/ui'

interface LoginProps {
    redirectUrl: string
    noAccountAlert: boolean
}

const Login = ({ redirectUrl, noAccountAlert = false } : LoginProps) => {
    return (
        <>
            <TitleBackgroundBlock
              id='providers-login'
              heading='Provider login'
              className={'bg-primary text-white'}
              description=''
              image={{
                src: undefined,
                className: 'hidden'
              }}
              alignment='left'
            />
            <Container className={'grid grid-cols-12 pt-12 lg:pt-15'}>
                <div className="col-span-12 flex flex-col md:flex-row gap-5 w-full scl-rich-text pb-8">
                    <h2 className="text-2xl md:text-3xl font-medium">Login for Sharp Community physicians and staff</h2>
                </div>
                <div className={'col-span-12 flex flex-col md:flex-row gap-5 w-full'}>
                     <Button
                        href='#'
                        rel='noopener noreferrer'
                        color='primary'
                        variant='filled'
                        size="md"
                        width="lg"
                        aria-label=""
                        onClick={() => signIn('okta', { callbackUrl: redirectUrl })}
                    >
                        Log in
                    </Button>
                </div>
                { noAccountAlert && (
                    <Container className="mt-6 mb-3 col-span-12 flex flex-col md:flex-row w-full login-alert">
                        <Alert severity='warning' variant='outlined' icon='triangle-exclamation'>
                        <Typography>
                            Sorry, we can’t find your account. Please use our <Link href="/providers/request-account">request form</Link> to access the Sharp Community provider website.
                        </Typography>
                        </Alert>
                    </Container>
                )}
            </Container>
        </>
    )
}

export default Login


